import React from 'react'
import PropTypes from 'prop-types'
import { useForm } from 'react-hook-form'
import { Row, Column, TextField, Button, Checkbox } from 'quantic'
import { Title } from '../styles'

function Register(props) {
  const { onSubmitRegister } = props
  const { handleSubmit, register, errors } = useForm()

  return (
    <form onSubmit={handleSubmit(onSubmitRegister)}>
      <Row>
        <Column size={12}>
          <Title>Cadastre-se</Title>
        </Column>
        <Column size={6}>
          <TextField
            name="name"
            label="Nome"
            ref={register({ required: 'Campo obrigatório' })}
            error={errors.name?.message}
            fullWidth
          />
        </Column>
        <Column size={6}>
          <TextField
            name="surname"
            label="Sobrenome"
            ref={register({ required: 'Campo obrigatório' })}
            error={errors.surname?.message}
            fullWidth
          />
        </Column>
        <Column size={12}>
          <TextField
            name="email"
            label="E-mail"
            fullWidth
            ref={register({
              required: 'Campo obrigatório',
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: 'Formato de e-mail inválido',
              },
            })}
            error={errors.email?.message}
          />
        </Column>
        <Column size={12}>
          <TextField
            name="phone"
            label="Telefone"
            mask="(99) 99999-9999"
            ref={register({ required: 'Campo obrigatório' })}
            error={errors.phone?.message}
            fullWidth
          />
        </Column>
        <Column size={12}>
          <TextField
            name="password"
            type="password"
            label="Senha"
            ref={register({ required: 'Campo obrigatório' })}
            error={errors.password?.message}
            fullWidth
          />
        </Column>
        <Column size={12}>
          <div style={{ display: 'flex' }}>
            <Checkbox
              name="termsAndConditions"
              ref={register({ required: 'Campo obrigatório' })}
              error={errors.termsAndConditions?.message}
            />
            Aceitar Termos e Condições
          </div>
        </Column>
        <Column justifyContent="flex-end" size={12}>
          <Button primary fullWidth type="submit">
            Cadastrar
          </Button>
        </Column>
      </Row>
    </form>
  )
}

Register.propTypes = {
  onSubmitRegister: PropTypes.func.isRequired,
}

export default Register
